export enum ServiceTabName {
  All = '1',
  Design = '2',
  Сonstruction = '3',
  RoughWork = '4',
  Communications = '5',
  Finishing = '6',
  Improvement = '7',
}

export type ServiceGroupStructure = {
  name: string;
  engName: string;
  iconSrc: string;
  list: string[];
};
